import auth from "@/router/middleware/auth";
import permission from "@/router/middleware/permission";

export default [
//******* Evento *******
    {
        path: '/venta-offline',
        name: 'event.offline',
        meta: {middleware: [auth, permission], permission: 'b2b.offline'},
        component: () => import('../views/event/offline/venta'),
    },
]